import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/inquery/inqueries',
    method: 'get',
    params: query
  })
}

export function createInquery(data) {
  return request({
    url: '/inquery/inqueries',
    method: 'post',
    data
  })
}

export function updateInquery(id, data) {
  return request({
    url: '/inquery/inquery/' + id,
    method: 'patch',
    data
  })
}

export function submitInquery(id) {
  return request({
    url: '/inquery/submit/' + id,
    method: 'post'
  })
}

export function fetchInquery(id, query) {
  return request({
    url: '/inquery/inquery/' + id,
    method: 'get',
    params: query
  })
}

export function sendInquery(insurance_id, data) {
  const query = {insurance_id: insurance_id}
  return request({
    url: '/inquery/send',
    method: 'post',
    params: query,
    data
  })
}

export function deleteInquery(id, data) {
  return request({
    url: '/inquery/inquery/' + id,
    method: 'delete',
    data
  })
}

export function getReply(id) {
  return request({
    url: '/inquery/get-reply/' + id,
    method: 'get'
  })
}

export function fetchCheck(insurance_id) {
  const query = {
    insurance_id: insurance_id
  }
  return request({
    url: '/inquery/fetch-check',
    method: 'get',
    params: query
  })
}

export function quotedSave(id, data) {
  return request({
    url: '/inquery/quoted-save/' + id,
    method: 'post',
    data
  })
}

export function adjustedSave(id, data) {
  return request({
    url: '/inquery/adjusted-save/' + id,
    method: 'post',
    data
  })
}

export function inqueryCheck(id, data) {
  return request({
    url: '/inquery/check/' + id,
    method: 'post',
    data
  })
}

export function inqueryCheckEmail(id, data) {
  return request({
    url: '/inquery/check-email/' + id,
    method: 'post',
    data
  })
}

export function createInqueryAdjust(data) {
  return request({
    url: '/inquery/adjusts',
    method: 'post',
    data
  })
}

export function fetchInqueryAdjustList(query) {
  return request({
    url: '/inquery/adjusts',
    method: 'get',
    params: query
  })
}

export function getObjInfo(query) {
  return request({
    url: '/inquery/get-obj-info',
    method: 'get',
    params: query
  })
}

export function getShipPolicy(query) {
  return request({
    url: '/inquery/get-ship-policy',
    method: 'get',
    params: query
  })
}


export function rateSave(id, data) {
  return request({
    url: '/inquery/rate-save/' + id,
    method: 'post',
    data
  })
}

export function inqueryCheckBatch(data) {
  return request({
    url: '/inquery/check-batch',
    method: 'post',
    data
  })
}
